/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
// idSlice.js
import { createSlice } from '@reduxjs/toolkit';


const initialState={
    selectedRows:{
        selectedIds:[],
        topCheckBox:[],
        
    }
    
}
const selectedRowsSliceConditionally = createSlice({
    name: 'selectedRowsConditionally',
    initialState: initialState,
    reducers: {
        selectLinkedDevicesOfPatients:(state,action) => {
            state.selectedRows.selectedIds.push(...action.payload)
        },
        toggleRowSelection: (state, action) => {
            
            const indexToUpdate = state.selectedRows.selectedIds.findIndex((selected) => selected?.id === action.payload[0]);
            if (indexToUpdate !== -1) {
                // If an object with the same 'id' exists, remove it
                state.selectedRows.selectedIds.splice(indexToUpdate, 1);
                if(state.selectedRows.topCheckBox.some((obj)=>obj.page_number===action.payload[1])){

                    const foundObj=state.selectedRows.topCheckBox.find((obj) => obj.page_number === action.payload[1]);

                    if (foundObj) {
                        // Modify the object's properties
                        foundObj.isChecked = false;
                    }
                }
                
            }
            else{
            // Add the new object to the array
                state.selectedRows.selectedIds.push({'id':action.payload[0],'name':action.payload[2],'status':action.payload[3]});
                const filteredArray = state.selectedRows.selectedIds.filter(obj1 =>
                    action.payload[2].some(obj2 => obj2.device_id === obj1.id )
                );
                const count=filteredArray.length
                if(count==parseInt((action.payload[2]).length)){
                    
                    const foundObj=state.selectedRows.topCheckBox.find((obj) => obj.page_number === action.payload[1]);
                    if(!foundObj){
                        state.selectedRows.topCheckBox.push({page_number:action.payload[1], isChecked:true });
                    }
                    else{
                        foundObj.isChecked=true
                    }
                }
                else{
                    const foundObj=state.selectedRows.topCheckBox.find((obj) => obj.page_number === action.payload[1]);
                    if(foundObj){
                        foundObj.isChecked=false
                    }
                    else{
                        state.selectedRows.topCheckBox.push({page_number:action.payload[1], isChecked:false });
                    }
                }
            }
            

        },
        selectAllRows:(state,action)=>{
            const isChecked=action.payload[0]
            const pageNumber=action.payload[1]
            const list=action.payload[2].map((item)=>({id:item.user_id || item.template_id,name:item.user_name||item.template_name,status:item.status}))
            if(isChecked){
                const uniqueSet = new Set(state.selectedRows.selectedIds.map(item => item.id));
                list.forEach(item => {
                    if (!uniqueSet.has(item.id)) {
                        state.selectedRows.selectedIds.push(item);
                        uniqueSet.add(item.id);
                    }
                });
                // state.selectedRows.selectedIds=Array.from(uniqueSet)
                const objectToUpdate=state.selectedRows.topCheckBox.find((checkbx)=>checkbx.page_number===pageNumber)
                if(objectToUpdate){
                    objectToUpdate.isChecked=true
                }
                else{
                    state.selectedRows.topCheckBox.push({"page_number":pageNumber,isChecked:true})
                }
                
               
            }
            else{
                const filteredArray = state.selectedRows.selectedIds.filter(item => {
                    // Check if the selectedItem's user_id is not in the list
                    return !list.some(listItem => listItem.id === item.id);
                });
                state.selectedRows.selectedIds=filteredArray
                const objectToUpdate=state.selectedRows.topCheckBox.find((checkbx)=>checkbx.page_number===pageNumber)
                objectToUpdate.isChecked=false
            }
        },
        resetArrays:(state)=>{
            state.selectedRows.selectedIds=[]
            state.selectedRows.topCheckBox=[]
        }
            
        ,
        removeRow:(state,action)=>{
            const indexToUpdate = state.selectedRows.selectedIds.findIndex((selected) => selected === action.payload);
            if (indexToUpdate !== -1) {
                
                // If an object with the same 'id' exists, remove it
                state.selectedRows.selectedIds.splice(indexToUpdate, 1);
                
            }
        },
        
        
        selectAllDeviceRows:(state,action)=>{
            const isChecked=action.payload[0]
            const pageNumber=action.payload[1]
            const list=action.payload[2].map((item)=>({id:item.device_id, is_assigned: item.is_assigned, status: item.status}))
            if(isChecked){
                const uniqueSet = new Set(state.selectedRows.selectedIds.map(item => item.id));
                list.forEach(item => {
                    if (!uniqueSet.has(item.id)) {
                        state.selectedRows.selectedIds.push(item);
                        uniqueSet.add(item.id);
                    }
                });
                // state.selectedRows.selectedIds=Array.from(uniqueSet)
                const objectToUpdate=state.selectedRows.topCheckBox.find((checkbx)=>checkbx.page_number===pageNumber)
                if(objectToUpdate){
                    objectToUpdate.isChecked=true
                }
                else{
                    state.selectedRows.topCheckBox.push({"page_number":pageNumber,isChecked:true})
                }
                
            }
            else{
                const filteredArray = state.selectedRows.selectedIds.filter(item => {
                    // Check if the selectedItem's user_id is not in the list
                    return !list.some(listItem => listItem.id === item.id);
                });
                state.selectedRows.selectedIds=filteredArray
                const objectToUpdate=state.selectedRows.topCheckBox.find((checkbx)=>checkbx.page_number===pageNumber)
                objectToUpdate.isChecked=false
            }
        },
        limitReducer:(state,action)=>{
            const allExistMethod1 = action?.payload[0]?.data?.every((item2) =>
                state.selectedRows.selectedIds.some((item1) => item1?.id === item2?.device_id)
            )
            if(allExistMethod1){
                const doesExist = state?.selectedRows?.topCheckBox?.find(obj => obj.page_number === action.payload[2]);

                if (!doesExist) {
                // If the item doesn't exist, add it to the array
                    state.selectedRows.topCheckBox.push({"page_number":action.payload[2].toString(),isChecked:true});
                }
                else{
                    doesExist.isChecked=true
                }

            }
            else{
                const doesExist = state?.selectedRows?.topCheckBox?.find(obj => obj.page_number === action.payload[2]);
                if(doesExist){
                    doesExist.isChecked=false
                }
                else{
                    state.selectedRows.topCheckBox.push({"page_number":action.payload[2].toString(),isChecked:false});
                }
            }
            
        },
      
       
    
    }
});



export const {selectLinkedDevicesOfPatients, toggleRowSelection,selectAllRows,resetArrays,removeRow,limitReducer, selectAllDeviceRows} = selectedRowsSliceConditionally.actions;
export default selectedRowsSliceConditionally.reducer;
